import styled, { keyframes } from 'styled-components';

import { MOBILE } from '../../mobile.tokens';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

export const Screen = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: ${MOBILE.screenBg};
`;

export const Centre = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding-top: 8%;
`;

export const Mark = styled.div<{ $mask: string }>`
  width: 110px;
  height: 128px;
  background: ${MOBILE.white};
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  mask-image: ${({ $mask }) => $mask};
  -webkit-mask-image: ${({ $mask }) => $mask};
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-position: center;
  -webkit-mask-position: center;
`;
